$shm_hitalama_map_book_widgets3 $mol_page
	map $shm_hitalama_map
	Map_page $shm_hitalama_map_page
		go_to_widget* => go_to_widget*
	editor_mode_enabled false
	widget_list_visible? false
	filter? \
	title \Виджеты
	head /
		<= Head $shm_list_head
			title <= title
			filter? <=> filter? \
			add_content /
				<= Add_widget $mol_pop_over
					align \right_bottom
					Anchor <= Add_widget_anchor $mol_button_minor
						sub /
							<= Add_widget_icon $mol_icon_plus
							\Добавить
					bubble_content /
						<= Add_widget_menu $shm_hitalama_map_page_contextmenu
							Map_page <= Map_page
							contextmenu_real_pos /
								0
								0
							widget_add* <= widget_add* null
			filter_content /
				<= Show_removed $mol_check_box
					title \Удаленные
					checked? <=> show_removed? true
			close? <=> close_widgets_list? null
	body /
		<= Tree $shm_hitalama_dragtree
			roots? <=> tree_roots? /
			children*? <=> tree_children*? /
			expanded*? <=> widget_expanded*? true
			can_have_children* <= can_have_children* true
			Item* <= Widget_item* $mol_view
				sub /
					<= Widget_title* $mol_view
						sub <= widget_title_content* /
				attr *
					^
					selected <= widget_selected* false
		^ removed_widgets_visible / <= Removed_widgets $mol_list
			rows <= removed_widget_rows /
	Widget_title_button*0 $mol_button_minor
		sub /
			<= Widget_icon* $mol_icon_square_outline
			<= Widget_title_text* $mol_view
				sub /
					<= widget_title* \
		click? <=> widget_click*? null
		clicks? <=> widget_rename_start*? null
	Widget_title_input*0 $mol_string
		value? <=> widget_title_draft*? \
		submit? <=> widget_rename_submit*? null
		event *
			^
			pointerdown? <=> widget_rename_pointerdown*? null
			blur? <=> widget_rename_submit*? null
			keydown? <=> widget_rename_keydown*? null
	Removed_widget_item*0 $mol_view
		attr *
			^
			removed true
		sub /
			<= Removed_widget_line* $mol_view
				sub /
					<= Removed_widget_title* $mol_view
						sub /
							<= Widget_icon*
							<= Widget_title_text*
					<= Widget_restore* $mol_button_minor
						title \Восстановить
						click? <=> widget_restore*? null
	Editor_widget_item*0 $mol_view
		sub /
			<= Editor_widget_line* $mol_view
				sub /
					<= Widget_link* $mol_link
						sub /
							<= Widget_icon*
							<= Widget_title_text*
						uri <= edit_widget_uri* \
						event *
							^
							dragstart? <=> widget_link_dragstart*? null
